import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import RaisedButton from 'material-ui/RaisedButton';
import SecurityQuestionModal from './security-question-modal';
import { deleteSecurityQuestion, getSecurityQuestion } from '../actions/SecurityQuestionActions';
import Alert from 'react-s-alert';
import PaginatorCustom from '../../../../../components/paginationCustom';
import { Field, reduxForm, reset } from 'redux-form';
import { renderTextField } from '../../../../../components/reduxFields';
import SortingCustom from '../../../../../components/SortingCustom';
import { resetFiltersAndSorting, alertConfirmation } from '../../../../../actions/utilAction';

class SecurityQuestionList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      securityQuestionId: null,
    };
    this.filter = {
      sort_Column: 'id',
      searchText: '',
      sort_order: 'desc',
    };

    this.handleSearchSecurityQuestion = this.handleSearchSecurityQuestion.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
  }
  loadData(page_number) {
    let searchObj = {
      sort_fields: this.filter.sort_Column ? this.filter.sort_Column : 'id',
      sort_order: this.filter.sort_order ? this.filter.sort_order : 'asc',
      contain_filters: { Question: this.filter.searchText ? this.filter.searchText : undefined },
      page_number: page_number ? page_number : 1,
    };
    this.props.getSecurityQuestion(searchObj);
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_order = col_order;
      this.loadData();
    }
  }
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.postSecurityQuestion && this.props.postSecurityQuestion !== nextProps.postSecurityQuestion) {
      this.loadData();
    }
    if (nextProps.DeleteSecurityQuestion && this.props.DeleteSecurityQuestion !== nextProps.DeleteSecurityQuestion) {
      this.loadData();
    }
  }
  componentWillMount() {
    this.loadData();
  }

  componentWillUnmount() {
    Alert.closeAll();
  }
  handleReset = () => {
    Alert.closeAll();
    this.props.dispatch(reset('SecurityQuestionListForm'));
    resetFiltersAndSorting(this.filter, 'id', false);
    this.setState({
      Question: null,
    }, () => {
      this.loadData();
    });
  };
  handleOpen = () => {
    Alert.closeAll();
    this.setState({ open: true, securityQuestionId: null });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  handleAlertClick = (event, id) => {
    this.props.deleteSecurityQuestion(id);
    Alert.closeAll();
  }
  handleDeleteClick = (event, obj) => {

    alertConfirmation('Are you sure you want to delete the Security question ?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: obj.id,
      },
    });
  }

  handleEditClick = (event, obj) => {
    Alert.closeAll();
    this.setState({ open: true, securityQuestionId: obj.id });
    // console.log("role data.......",);
  }

  handleSearchSecurityQuestion(event) {
    if (event.SecurityQuestion !== undefined) {
    }
  }

  handleSearchChange(event) {
    if (event.target.value.length > 2) {
      this.filter.searchText = event.target.value;
      this.loadData();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadData();
    }
  }

  renderData() {
    return this.props.securityQuestions.map((Obj, index) => {
      return (
        <tr key={index}>
          <td>{Obj.question}</td>
          <td className={Obj.isActive === true ? 'greenfont' : 'redfont'}>{Obj.isActive === true ? 'Active' : 'Inactive'}</td>
          {this.props.updatePermission || this.props.deletePermission ?
            <td>
              {
                this.props.updatePermission ?
                  <button onClick={(e) => this.handleEditClick(e, Obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                  : null
              }
              {
                this.props.deletePermission ?
                  <button onClick={(e) => this.handleDeleteClick(e, Obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                  : null
              }
            </td>
            : null
          }
        </tr>
      );
    });
  }

  render() {
    const { handleSubmit } = this.props;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.condensed,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
    });

    return (
      <div>
        <h2 className="page_title">Manage Security Question</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <div className="modalwindow">
              <div className="row">
                <div className="col-sm-5">
                  {this.props.addPermission ?
                    <RaisedButton label="Add Question" primary={true} onTouchTap={this.handleOpen} />
                    : null
                  }
                </div>
                <div className="col-sm-7">
                  <div className="row end-flex">
                    <div className="col-sm-6 mtm-27">
                      <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchSecurityQuestion)}>
                        <Field
                          name="Question"
                          floatingLabelText="Search"
                          maxLength='15'
                          onChange={this.handleSearchChange}
                          component={renderTextField}
                        />
                      </form>
                    </div>
                    <div className="reset-btn col-sm-3 btn_rt">
                      <RaisedButton label="Reset" className="grey_btn ml_15" onTouchTap={this.handleReset} />
                    </div>
                  </div>
                </div>
              </div>
              {this.state.open ? <SecurityQuestionModal securityQuestionId={this.state.securityQuestionId} closeDialog={this.handleClose} /> : null}
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="table-responsive mt-15">
                  {this.props.securityQuestions ? this.props.securityQuestions.length ?
                    <table className={tableClass}>
                      <thead>
                        <tr>
                          <th width="40%"><SortingCustom setSortColumn={this.setSortColumn} columnName='Question' displayName='Question' /></th>
                          <th width="40%">Status</th>
                          {this.props.updatePermission || this.props.deletePermission ?
                            <th width="20%">Actions</th>
                            : null
                          }
                        </tr>
                      </thead>
                      <tbody>
                        {this.renderData()}
                      </tbody>
                    </table>
                    :
                    <table className={tableClass}>
                      <thead>
                        <tr>
                          <th width="40%">Question</th>
                          <th width="40%">Status</th>
                          {this.props.updatePermission || this.props.deletePermission ?
                            <th width="20%">Actions</th>
                            : null
                          }
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colSpan="3">
                            <div className="familydl text-center no-record">No record found.</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    : null}
                  {this.props.metaData && this.props.metaData.totalPages ?
                    <PaginatorCustom data={this.props.metaData} handlePageChange={(page_number) => this.loadData(page_number)} />
                    : null
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SecurityQuestionList = reduxForm({
  form: 'SecurityQuestionListForm',
})(SecurityQuestionList);

function mapStateToProps(state) {
  // console.log('state.securityQuestions......', state.securityQuestions);
  // Start For Role Permission
  let userActionPermission = [], securityQuestions = [], metaData = null;
  if (state.mastersecurityQuestions.getSecurityQuestions && state.mastersecurityQuestions.getSecurityQuestions.data) {
    securityQuestions = state.mastersecurityQuestions.getSecurityQuestions.data;
    metaData = state.mastersecurityQuestions.getSecurityQuestions.meta;
    // console.log('state', state.diagnosisCode.diagnosisCodesList.data);
  };
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'MASTERS');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'MASTERS_SECURITYQUESTIONS_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_SECURITYQUESTIONS_LIST_ADD')[0].permission : false;
  let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_SECURITYQUESTIONS_LIST_UPDATE')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_SECURITYQUESTIONS_LIST_DELETE')[0].permission : false;

  // End For Role Permission
  return {
    securityQuestions: securityQuestions,
    postSecurityQuestion: state.mastersecurityQuestions.postSecurityQuestion,
    DeleteSecurityQuestion: state.mastersecurityQuestions.deleteSecurityQuestion,
    meta: metaData,
    addPermission: addPermission,
    updatePermission: updatePermission,
    deletePermission: deletePermission,
  };
}
export default connect(mapStateToProps, { getSecurityQuestion, deleteSecurityQuestion })(SecurityQuestionList);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/securityQuestions/components/security-question.js